import { Box, useTheme } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import Text from "../../../../../../components/theme/text/Text";
import { tokens } from "../../../../../../theme";

import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from "react-i18next";
import MAddLocationBundleTemplate from "../../../../../../components/global/Modals/MAddLocationBundleTemplate";
import ButtonGroup from "../../../../../../components/theme/buttons/ButtonGroup";
import Shbutton from "../../../../../../components/theme/buttons/Shbutton";
import ShDataGrid2 from "../../../../../../components/theme/datagrid2/ShDataGrid2";
import SidepanelLoader from "../../../../../../components/theme/sidepanel2/SidepanelLoader";
import ShTextSkeleton from "../../../../../../components/theme/skeleton/ShTextSkeleton";
import { useGetLocationBundleTemplatesQuery } from "../../../../../../newapi/warehouse/locationBundleTemplateSlice";
import { selectUserPermission } from "../../../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from '../../../../../../utils/permissions';
import { useSelector } from "react-redux";
import { WarehouseLocationTypeCard } from "../../../../../../components/global/cards/settings/WarehouseCard";
import ShLabel from "../../../../../../components/theme/label/ShLabel";
import { getWarehouseLocationLabelData } from "../../../../../../utils/labelColorText";

const SpLocationBundleTemplateDetails = SidepanelLoader(() => import("../../../../../../components/global/Sidepanels/SpLocationBundleTemplateDetails/SpLocationBundleTemplateDetails"));

const GridActions = (props, i18n) => {
    const theme = useTheme();
    useEffect(() => {},[props.open]);

    const {t} = useTranslation();
    return (      
        <ButtonGroup version={2}>
            {props.hasCreatePermission && (
            <Shbutton 
                onClick={() => props.handleOpen(true)}
                className={"group-btn"} 
                color={theme.palette.mode === "dark" ? "blue" : "primary"} 
                variant="contained" 
                endIcon={<AddIcon/>}>{t("new_location_bundle_template")}</Shbutton>
            )}
        </ButtonGroup>
    )
}

const gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
    

};

const LocationBundleTemplates = (props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [isExtended,setIsExtended] = useState(false);
    const [spLoading, setSpLoading] = useState();

    const hasCreatePermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.WAREHOUSE_MANAGE])
    );

    const [addModalOpen, setAddModalOpen] = useState(false);
    const addModal = {
        open: addModalOpen,
        setOpen: setAddModalOpen
    }

    const handleClose = () => {
        setAddModalOpen(false);
      };

    const [locationBundleTemplateId, setLocationBundleTemplateId] = useState();
    const locationBundleTemplateIdRef = useRef(locationBundleTemplateId);
    
    const getLocationBundleTemplateDetails = (params) => {
        if (!params) return;
    
        const newLocationBundleTemplateId = parseInt(params.row.id);
        // Only update state if the warehouseLocationTypeId has actually changed
        if (locationBundleTemplateIdRef.current !== newLocationBundleTemplateId) {
            if(!spLoading) {
                setSpLoading(true);
            }
            setLocationBundleTemplateId(newLocationBundleTemplateId);
            locationBundleTemplateIdRef.current = newLocationBundleTemplateId; // Update the ref to the new value
        }
        setIsExtended(true);
    };
    
    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions:gridOptions,
            mobileActions:<GridActions handleOpen={() => setAddModalOpen(true)} hasCreatePermission={hasCreatePermission}></GridActions>
        });

        return () => {
            // console.log("unmounting warehouse");
        }
    },[]);

    const columns = [
        {field: "name", 
        headerName: t("name"), 
        flex:2, 
        renderCell : (cellValues) => {
            if(cellValues.row.skeleton) {
                return <ShTextSkeleton/>
            }

            return (
                <Text semibold>{cellValues.value}</Text>
            )
        }},
        {field: "carryingCapacity", 
        headerName: `${t("carrying_capacity")} (${t("kg")})`, 
        flex:1, 
        renderCell : (cellValues) => {
            if(cellValues.row.skeleton) {
                return <ShTextSkeleton/>
            }

            return cellValues.row.carryingCapacity
        }},
        {field: "conditionCount", 
        headerName: t("conditions"), 
        flex:1, 
        renderCell : (cellValues) => {
            if(cellValues.row.skeleton) {
                return <ShTextSkeleton/>
            }

            return cellValues.row.conditions?.carriers?.length
        }},
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (cellValues) => {
                return(
                    <WarehouseLocationTypeCard
                        skeleton={cellValues.row.skeleton ?? false}
                        {...cellValues.row}
                        onClick={() => getLocationBundleTemplateDetails(cellValues)}
                    />
                )
            }
        }
    ];
    
    return (
        <Box
            sx={{
                height:1,
                "@media screen and (max-width: 47.9375em)" : {
                    paddingTop:0,
                    paddingX:0,
                }
            }}
        >
            
            <ShDataGrid2 key={theme.palette.mode}
                content={useGetLocationBundleTemplatesQuery}
                gridActions={<GridActions handleOpen={() => setAddModalOpen(true)} hasCreatePermission={hasCreatePermission}></GridActions>} 
                title={t('overview')} 
                gridOptions={gridOptions} 
                
                sortModel={{field: columns[0].field,type:"ASC"}}
                columns={columns} 
                onRowClick={getLocationBundleTemplateDetails}>
            </ShDataGrid2>
            <MAddLocationBundleTemplate onOpen={() => addModal.setOpen(true)} onClose={() => addModal.setOpen(false)} open={addModal.open} handleClose={handleClose}/>

            {spLoading && 
                <SpLocationBundleTemplateDetails
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    locationBundleTemplateId={locationBundleTemplateId}
                    // data={warehouseLocationTypeData}  
                /> 
            }
        </Box>
    )
};

export default LocationBundleTemplates;